<template>
  <div class="tw-flex tw-flex-col tw-gap-[30px] tw-p-[30px] tw-h-full">
    <div>
      <img
        src="/assets/images/logos/login-logo.svg"
        alt="TopHelpers"
        class="tw-w-[200px] tw-m-[0_auto_15px]"
      >
      <div class="tw-text-center">
        <h3 class="tw-text-secondary tw-text-[26px] tw-font-[600]">
          Thank you, {{ fullName }}!
        </h3>
        <p>We appreciate your booking with TopHelpers.</p>
      </div>
    </div>

    <div class="tw-grid tw-gap-[15px] tw-p-[15px] tw-border tw-border-solid tw-border-[#E4E8FF] tw-rounded-[8px]">
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-[15px]">
        <div class="tw-flex tw-items-center tw-gap-[10px]">
          <i class="icony icony-check-circle tw-text-[green]"></i>
          <span>Order: <strong>#{{ rateableOrder.id }} - ${{ rateableOrder.price }}</strong> USD</span>
        </div>
        <div>
          <strong>{{ rateableOrder.type === 'order' ? 'Moving Order' : 'Delivery Order' }}</strong>
        </div>
      </div>

      <h4 class="tw-text-secondary tw-text-[20px] tw-font-[600]">
        Rate your experience
      </h4>

      <v-rating
        v-model="rate"
        half-icon="fa-star-half-alt"
        size="18"
        color="#FBAB1E"
        background-color="#FBAB1E"
        class="custom--v-rating"
      />

      <textarea
        v-model="review"
        type="text"
        v-maska
        maxlength="300"
        class="tw-w-full tw-p-[5px_10px] tw-bg-[#F4F6FF] tw-border tw-border-solid tw-border-black/10 tw-rounded-[8px] tw-outline-none placeholder:tw-text-black/50"
        placeholder="Tell us about your experience (optional)"
      ></textarea>
    </div>

    <div>
      <h4 class="tw-mb-[15px] tw-text-secondary tw-text-[20px] tw-font-[600]">
        How did you first discover TopHelpers?
      </h4>
      <div class="tw-flex tw-flex-wrap tw-gap-[5px]">
        <div v-for="(item, index) in options" :key="index">
          <button
            @click="onClickOption(item)"
            class="tw-p-[5px_15px] tw-text-[14px] tw-font-[500] tw-rounded-[8px] tw-duration-300"
            :class="option === item ? 'tw-bg-secondary tw-text-white' : 'tw-bg-[#eee] tw-text-secondary hover:tw-bg-[#E4E8FF]'"
          >
            {{ item }}
          </button>
        </div>
        <input
          v-if="option === 'Other'"
          v-model="otherOption"
          type="text"
          v-maska
          maxlength="35"
          class="tw-w-full tw-mt-[10px] tw-p-[5px_10px] tw-bg-[#F4F6FF] tw-border tw-border-solid tw-border-black/10 tw-rounded-[8px] tw-outline-none placeholder:tw-text-black/50"
          placeholder="Please specify..."
        >
      </div>
    </div>

    <div class="tw-flex tw-justify-end tw-gap-[10px] tw-mt-auto">
      <button
        @click="onClickSkip"
        class="tw-p-[5px_15px] tw-bg-white tw-font-[600] tw-text-black/50 tw-rounded-[8px] tw-duration-300 hover:tw-text-secondary"
      >
        Skip for now
      </button>
      <button
        @click="onClickSubmit"
        class="tw-p-[5px_15px] tw-bg-primary tw-font-[600] tw-text-white tw-rounded-[8px] tw-duration-300 hover:tw-bg-secondary"
      >
        Submit Feedback
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { maska } from 'maska';

export default {
  directives: {
    maska
  },

  data() {
    return {
      review: '',
      rate: 0,
      option: '',
      otherOption: '',
      options: [
        'Google Search',
        'Facebook & Instagram',
        'YouTube & TikTok',
        'Email',
        'Flyer / Business Card / Poster',
        'Word of Mouth / Friend Referral',
        'Other'
      ]
    }
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapState('rate_platform', ['rateableOrder']),

    fullName() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },

    renderedOtherOption() {
      if (this.option !== 'Other') return this.option;
      return this.otherOption.trim() ? `Other: ${this.otherOption}` : 'Other';
    }
  },

  methods: {
    ...mapActions('rate_platform', ['customerRatePlatform']),

    onClickOption(item) {
      this.option = this.option === item ? null : item;
    },

    closeModal() {
      this.$emit('close');
    },

    async ratePlatform(isSkipped) {
      await this.customerRatePlatform({
        skipped: isSkipped,
        rate: isSkipped && this.rate === 0 ? null : this.rate,
        review: this.review,
        how_find: this.renderedOtherOption
      });
    },

    async onClickSkip() {
      await this.ratePlatform(true);
      this.closeModal();
    },

    async onClickSubmit() {
      await this.ratePlatform(false);
      this.closeModal();
    }
  }
};
</script>
